import Bookings from './Bookings'
import CourierDeliveryDetails from './components/CourierDeliveryDetails'
import DarazStatementDetails from './components/DarazStatementDetails'
import PaymentInvoiceDetail from './components/PaymentInvoicesDetail'
import PaymentReceivedDetail from './components/PaymentReceivedDetail'
import DiscrepancyDetails from './components/payments/components/DiscrepancyDetails'
import CourierWiseDetail from './components/payments/CourierWiseDetail'
import MonthWiseDetail from './components/payments/MonthWiseDetail'
import ReconciliationMonthWiseDetail from './components/ReconciliationMonthWiseDetail'
import DarazStatements from './DarazStatements'
import PaymentGateways from './paymentGateways/PaymentGateways'
import PaymentCourierWise from './PaymentsCourierWise'
import PaymentsMonthWise from './PaymentsMonthWise'
import PaymentStatusWise from './PaymentStatusWise'
import ReceivedPayments from './ReceivedPayments'
import ReconciliationMonthWise from './ReconciliationMonthWise'
import UploadPayments from './UploadPayments'
import BankAccountDetail from '../../accounts/pages/BankAccounts/BankAccountDetail'
import BankAccounts from '../../accounts/pages/BankAccounts/BankAccounts'
export const ROUTES = [
  {
    component: DarazStatements,
    isPublic: true,
    path: '/payments',
    slug: 'courier',
    title: 'courier',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Bookings,
    isPublic: true,
    path: '/payments/bookings',
    slug: 'Bookings',
    title: 'Bookings',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: UploadPayments,
    isPublic: true,
    path: '/payments/upload-payments',
    slug: 'Bookings',
    title: 'Bookings',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: PaymentInvoiceDetail,
    isProtected: true,
    showMenu: true,
    path: '/payments/upload-payments/:id',
    slug: 'Bookings',
    title: 'Bookings',
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: ReceivedPayments,
    isPublic: true,
    path: '/payments/received-payments',
    slug: 'Bookings',
    title: 'Bookings',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: PaymentReceivedDetail,
    isPublic: true,
    path: '/payments/received-payments/details/:id',
    slug: 'Bookings',
    title: 'Bookings',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: PaymentsMonthWise,
    isPublic: true,
    path: '/payments/payments-month-wise',
    slug: 'Bookings',
    title: 'Bookings',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: PaymentStatusWise,
    isPublic: true,
    path: '/payments/payments-status-wise',
    slug: 'Bookings',
    title: 'Bookings',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: PaymentCourierWise,
    isPublic: true,
    path: '/payments/payments-courier-wise',
    slug: 'Bookings',
    title: 'Bookings',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: CourierWiseDetail,
    isPublic: true,
    path: '/payments/courier-wise-detail',
    slug: 'Bookings',
    title: 'Bookings',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: MonthWiseDetail,
    isPublic: true,
    path: '/payments/payments/month-wise-detail',
    slug: 'Bookings',
    title: 'Bookings',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: CourierDeliveryDetails,
    isPublic: true,
    path: '/payments/delivery-details',
    slug: 'courier',
    title: 'courier',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: DiscrepancyDetails,
    isPublic: true,
    path: '/payments/discrepant-details',
    slug: 'Bookings',
    title: 'Bookings',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: PaymentGateways,
    isProtected: true,
    showMenu: true,
    path: '/payments/payment-gateways',
    slug: 'payment-gateways',
    title: 'payment-gateways',
    redirectTo: '/auth/login',
  },
  {
    component: BankAccounts,
    isProtected: true,
    showMenu: true,
    path: '/accounts/bank-accounts',
    slug: 'bank-accounts',
    title: 'bank-accounts',
    redirectTo: '/auth/login',
  },
  {
    component: BankAccountDetail,
    isProtected: true,
    showMenu: true,
    path: '/accounts/bank-accounts/details/:id',
    slug: 'bank-account-details',
    title: 'bank-account-details',
    redirectTo: '/auth/login',
  },
  {
    component: DarazStatementDetails,
    isProtected: true,
    showMenu: true,
    path: '/payments/details',
    slug: 'daraz-details',
    title: 'daraz-details',
    redirectTo: '/auth/login',
  },
  {
    component: ReconciliationMonthWise,
    isPublic: true,
    path: '/analytics/reconciliation-month-wise',
    slug: 'Reports',
    title: 'Reports',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: ReconciliationMonthWiseDetail,
    isPublic: true,
    path: '/analytics/reconciliation-month-wise/details',
    slug: 'Reports',
    title: 'Reports',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
]
